"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _mapReducer = require("./mapReducer");

var _bookmarkReducer = require("./bookmarkReducer");

var _menuReducer = require("./menuReducer");

var _infoboxReducer = require("./infoboxReducer");

var _sc4Reducer = require("./sc4Reducer");

var _messageReducer = require("./messageReducer");

var _reportReducer = require("./reportReducer");

var _permissionsReducer = require("./permissionsReducer"); // import entities from './entities';


var rootReducers = {
  metadataReducer: _sc4Reducer.metadataReducer,
  infoboxReducer: _infoboxReducer.infoboxReducer,
  menuReducer: _menuReducer.menuReducer,
  summaryReducer: _sc4Reducer.summaryReducer,
  reportReducer: _sc4Reducer.reportReducer,
  messageReducer: _messageReducer.messageReducer,
  loadBookmarksReducer: _bookmarkReducer.loadBookmarksReducer,
  mapViewReducer: _mapReducer.mapViewReducer,
  mapBoundsReducer: _mapReducer.mapBoundsReducer,
  layerVisibilityReducer: _mapReducer.layerVisibilityReducer,
  deviceSizeReducer: _mapReducer.deviceSizeReducer,
  reportVisibilityReducer: _reportReducer.reportVisibilityReducer,
  layerPermissionReducer: _permissionsReducer.layerPermissionReducer // visibilityOptionReducer,

};
/**
 * A function that will use combineReducers to merge additional reducers with the root reducer
 * @param {*} additionalReducers
 */

var rootReducer = (0, _redux.combineReducers)(rootReducers);
var _default = rootReducer;
exports.default = _default;